<template>
  <LayoutPartnersLanguageTopBar
    class="tw-hidden lg:tw-block"
    :is-header-visible="isHeaderVisible"
    @toggle-dropdown="toggleMobileDropdown"
  />
  <nav
    class="navbar navbar-expand-lg fixed-top navbar-dark tw-transition-transform tw-duration-300"
    :class="isHeaderVisible ? ' tw-translate-y-12' : '-tw-translate-y-0'"
  >
    <div class="container navbar-container py-lg-0 py-3">
      <!-- Brand -->
      <NuxtLinkLocale to="/">
        <img
          width="180"
          src="/img/logo-white.svg"
        />
      </NuxtLinkLocale>
      <!-- Mobile toggle button -->
      <button
        id="toggle-navbar-btn"
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
        style="font-size: 16px"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Navigation items -->
      <div
        class="collapse navbar-collapse"
        id="navbarNav"
      >
        <LayoutNavigationItems
          class="tw-ml-4"
          @toggle-dropdown="toggleMobileDropdown"
          @item-clicked="itemClicked"
        />
        <!-- <div class="tw-flex tw-items-center d-lg-none">
          <LayoutLanguageSelector
            class="d-lg-none"
            @toggle-dropdown="toggleMobileDropdown"
          /> 
        </div> -->
        <i
          class="fa fa-search lg:tw-pl-0 tw-pl-7"
          style="color: #5f5f61"
        />
        <PrimaryButton
          variant="text-gray"
          size="md"
          @click="$router.push('/login')"
        >
          Login
        </PrimaryButton>
        <PrimaryButton
          size="md"
          @click="$router.push('/register')"
        >
          Register
        </PrimaryButton>
      </div>
    </div>
  </nav>
</template>

<script lang="ts" setup>
const isHeaderVisible = ref(false);
const lastScrollY = ref(0);

const handleScroll = () => {
  const currentScrollY = window.scrollY;
  if (window.innerWidth < 992) {
    isHeaderVisible.value = false;
    return;
  }
  if (currentScrollY > lastScrollY.value && currentScrollY > 50) {
    isHeaderVisible.value = false; // Scrolling down
  } else if (currentScrollY <= 150) {
    isHeaderVisible.value = true; // Scrolling up
  }
  lastScrollY.value = currentScrollY;
};

onMounted(() => {
  handleScroll();
  window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});

const toggleMobileDropdown = (event) => {
  // Only work on mobile screens
  if (window.innerWidth >= 992) return;

  const clickedItem = event.target.closest('.hover-dropdown');
  const dropdownMenu = clickedItem.querySelector('.dropdown-menu');
  const arrow = clickedItem.querySelector('.mobile-arrow');

  // Close all other dropdowns
  document.querySelectorAll('.hover-dropdown').forEach((item) => {
    if (item !== clickedItem) {
      const otherMenu = item.querySelector('.dropdown-menu');
      const otherArrow = item.querySelector('.mobile-arrow');
      otherMenu?.classList?.remove('mobile-show');
      otherArrow?.classList?.remove('rotated');
    }
  });

  // Toggle current dropdown
  dropdownMenu?.classList?.toggle('mobile-show');
  arrow?.classList?.toggle('rotated');
};

const itemClicked = () => {
  document.getElementById('toggle-navbar-btn')?.click();
};
</script>

<style lang="scss">
.navbar-container,
.top-bar {
  min-height: 80px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 23px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(0, 0, 0, 0.83);
  backdrop-filter: blur(10px);
}

.dropdown-menu {
  border: none;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  margin-top: 0.5rem;
}

.dropdown-item {
  padding: 0.75rem 1.5rem;
  transition: all 0.3s ease;
}

.dropdown-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* Mobile arrow for dropdowns */
.mobile-arrow {
  display: none;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 6px solid #fff;
  transition: transform 0.3s ease;
}

.mobile-arrow.rotated {
  transform: rotate(180deg);
}
/* Hover dropdown functionality */
.hover-dropdown {
  position: relative;
}

.hover-dropdown .dropdown-menu {
  display: none;
  visibility: hidden;
  opacity: 0;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  pointer-events: none; /* Prevent interaction when hidden */
}

.hover-dropdown:hover .dropdown-menu {
  display: block;
  visibility: visible;
  opacity: 1;
  transform: translateY(-8px);
  pointer-events: auto; /* Re-enable interaction */
}

/* Mobile responsiveness */
@media (max-width: 991.98px) {
  .navbar-nav {
    margin-top: 1rem;
  }

  /* Disable hover functionality on mobile */
  // .hover-dropdown:hover .dropdown-menu {
  //   display: none;
  //   opacity: 0;
  //   transform: translateY(-10px);
  // }
  /* Show mobile arrows */
  .mobile-arrow {
    display: inline-block;
  }

  /* Mobile dropdown styling */
  .dropdown-menu {
    position: static !important;
    transform: none !important;
    border: none;
    box-shadow: none;
    background: white;
    border-radius: 20px;
    backdrop-filter: blur(40px);
    margin-left: 1rem;
    color: black;
    visibility: hidden;
    // display: none !important;
    opacity: 0 !important;
    max-height: 0;
    overflow: hidden;
    transition: all 0.3s ease;
  }

  .dropdown-menu.mobile-show {
    // display: block !important;
    visibility: visible;
    opacity: 1 !important;
    max-height: 500px;
  }

  .dropdown-item {
    color: black;
    padding: 0.5rem 1rem;
  }

  .dropdown-item:hover {
    background-color: rgba(255, 255, 255, 0.1);
    color: var(--bs-primary);
  }
  .dropdown-header {
    color: var(--bs-primary);
    font-weight: bold;
  }
}
</style>
